export const Props = () => ({
  //--------------------------------------------------------------------------
  //                         Ссылка на внешний источник
  //--------------------------------------------------------------------------
  link: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                           Источник иконки (ссылка)
  //--------------------------------------------------------------------------
  image: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                           Источник контракта
  //--------------------------------------------------------------------------
  contract: {
    type: String,
    required: false,
  },
});